/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsUnityOptionsDistributionComponentOptions interface.
 */
export function instanceOfFxIdDomainSettingsUnityOptionsDistributionComponentOptions(value) {
    if (!('MatchWebGLToCanvasSize' in value) || value['MatchWebGLToCanvasSize'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsUnityOptionsDistributionComponentOptionsFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionComponentOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionComponentOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DevicePixelRatio': json['DevicePixelRatio'] == null ? undefined : json['DevicePixelRatio'],
        'AutomaticDevicePixelRatio': json['AutomaticDevicePixelRatio'] == null ? undefined : json['AutomaticDevicePixelRatio'],
        'MatchWebGLToCanvasSize': json['MatchWebGLToCanvasSize'],
    };
}
export function FxIdDomainSettingsUnityOptionsDistributionComponentOptionsToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionComponentOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionComponentOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DevicePixelRatio': value['DevicePixelRatio'],
        'AutomaticDevicePixelRatio': value['AutomaticDevicePixelRatio'],
        'MatchWebGLToCanvasSize': value['MatchWebGLToCanvasSize'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionComponentOptions.js.map